export const login = (values) => ({
  method: 'POST',
  endpoint: `/auth/login`,
  headers: {
    'Content-Type': 'application/json',
  },
  skipAuth: true,
  prefix: ' ',
  body: values
})

export const signup = (values) => ({
  method: 'POST',
  endpoint: `/auth/signup`,
  headers: {
    'Content-Type': 'application/json',
  },
  skipAuth: true,
  prefix: ' ',
  body: values
})

export const sendReferral = (values) => ({
  method: 'POST',
  endpoint: `/referrals/send`,
  headers: {
    'Content-Type': 'application/json',
  },
  body: values
})

export const forgotPassword = (values) => ({
  method: 'POST',
  endpoint: `/auth/password/forgot`,
  headers: {
    'Content-Type': 'application/json',
  },
  skipAuth: true,
  prefix: ' ',
  body: values
})

export const respondChallenge = (values) => ({
  method: 'POST',
  endpoint: `/auth/challenges/respond`,
  headers: {
    'Content-Type': 'application/json',
  },
  skipAuth: true,
  prefix: ' ',
  body: values
})

export const passwordChange = (values) => ({
  method: 'POST',
  endpoint: `/auth/password/recover`,
  headers: {
    'Content-Type': 'application/json',
  },
  skipAuth: true,
  prefix: ' ',
  body: values
})

export const verifyAccount = (values) => ({
  method: 'POST',
  endpoint: `/auth/verify-account`,
  headers: {
    'Content-Type': 'application/json',
  },
  skipAuth: false,
  prefix: ' ',
  body: values
})

export const resendVerificationCode = (values) => ({
  method: 'POST',
  endpoint: `/auth/verify-account/resend`,
  headers: {
    'Content-Type': 'application/json',
  },
  skipAuth: false,
  prefix: ' ',
  body: values
})